import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import theme from '../../theme';

const TelegramWhite = (props: SvgIconProps) => {
  const [isHover, setIsHover] = React.useState(false);
  return (
    <SvgIcon
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      {...props}
    >
      <path
        d="M28.907 3.96705C28.6314 3.72912 28.296 3.5711 27.9371 3.51012C27.5782 3.44914 27.2094 3.48752 26.8707 3.6211L3.8011 12.6842C3.39899 12.8422 3.05884 13.1261 2.83156 13.4935C2.60427 13.8609 2.50206 14.2921 2.54023 14.7224C2.5784 15.1527 2.75489 15.5591 3.0433 15.8808C3.3317 16.2025 3.71651 16.4221 4.14015 16.5068L10 17.6788V24.9981C9.99967 25.3938 10.1168 25.7807 10.3365 26.1098C10.5562 26.4389 10.8686 26.6954 11.2342 26.8469C11.5998 26.9983 12.0021 27.0378 12.3902 26.9605C12.7782 26.8831 13.1346 26.6923 13.4142 26.4122L16.6571 23.1694L21.5791 27.5007C21.9415 27.8225 22.4091 28.0005 22.8938 28.0011C23.1044 28.0009 23.3138 27.9677 23.5142 27.9027C23.8447 27.7979 24.142 27.6082 24.3763 27.3526C24.6107 27.097 24.7739 26.7844 24.8497 26.4461L29.5515 5.92945C29.6333 5.57468 29.6166 5.20428 29.503 4.85836C29.3894 4.51244 29.1833 4.20421 28.907 3.96705ZM22.9003 25.9993L12.6013 16.936L27.4318 6.22517L22.9003 25.9993Z"
        fill={isHover ? theme.palette.cyan : theme.palette.greyscale.white}
      />
    </SvgIcon>
  );
};

export default TelegramWhite;
